import { useState } from "react";
import { faqs } from "@/mocks/comics";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      {/* FAQPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium">
            <i className="ri-question-line" />
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">追更常见问题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            关于追更提醒、免费阅读、更新同步的疑问，这里都有答案。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`rounded-xl border bg-background-100 transition-colors ${
                  open ? "border-primary-300" : "border-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="font-medium text-foreground-950 text-sm md:text-base">{item.q}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform duration-300 ${
                      open ? "rotate-180 text-primary-600" : ""
                    }`}
                  />
                </button>
                {open && (
                  <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}